import React, { Component } from "react";
import { Link } from 'react-router-dom';

class Withdrawatm extends Component {
  render() {
    return (
      <div>
        <section className="breadcrumbs">
          <div className="container">
            <div className="row">
              <div className="col-sm-6 a-breadcrumbs" style={{color: '#ffffff'}}>
                <Link to="/home" className="a-breadcrumbs">หน้าแรก</Link>&nbsp;
                <i className="fa fa-angle-right" />&nbsp;<a href="withdrawatm" className="a-breadcrumbs">ขั้นตอนการกู้ฉุกเฉินและถอนเงิน ออมทรัพย์สหกรณ์ผ่านบัตร ATM ธนาคารกรุงศรี</a>
              </div>
            </div>
          </div>
        </section>
        <section className="page-section">
        <div className="container">
          <br/>
          <div className="row">
            <div className="col-md-9 col-sm-9 mb-sm-50">
              <div className="divider gray left mt-20 mb-25" />
              <img src="Img/WithDrawATM/Slide1.png" />
            </div>
          </div>
          <br/><br/>
          <div className="row">
            <div className="col-md-9 col-sm-9 mb-sm-50">
              <div className="divider gray left mt-20 mb-25" />
              <img src="Img/WithDrawATM/Slide2.png" />
            </div>
          </div>
        </div>
        </section>
      </div>
    );
  }
}

export default Withdrawatm;
